/* ============================================
   视频显示修复 - 只针对产品描述里的视频
   ============================================ */
(function() {
    function fixVideos() {
        // 只在产品描述区域找视频，不影响其他地方
        var selectors = [
            '.product-description video',
            '.rte video',
            '.disclosure__content video',
            '.product__description video',
            '.description video',
            '[class*="description"] video',
            '.media-with-text__media video'
        ];
        
        var videos = document.querySelectorAll(selectors.join(','));
        
        videos.forEach(function(video) {
            // 强制视频可见
            video.style.display = 'block';
            video.style.opacity = '1';
            video.style.visibility = 'visible';
            video.style.width = '100%';
            video.style.height = 'auto';
            video.style.minHeight = '200px';
            video.style.maxWidth = '100%';
            video.style.position = 'relative';
            video.style.zIndex = '1';
            video.style.backgroundColor = '#000';
            video.style.objectFit = 'contain';
            
            // 强制视频父容器可见
            var parent = video.parentElement;
            if (parent) {
                parent.style.opacity = '1';
                parent.style.visibility = 'visible';
                parent.style.overflow = 'visible';
                parent.style.minHeight = '200px';
            }
            
            // 显示控件
            video.controls = true;
            video.playsInline = true;
            
            console.log('✅ 视频已修复:', video.src || video.querySelector('source')?.src);
        });
    }
    
    // DOM 加载完成后执行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fixVideos);
    } else {
        fixVideos();
    }
    
    // 页面完全加载后再执行一次（覆盖延迟加载的视频）
    window.addEventListener('load', function() {
        setTimeout(fixVideos, 500);
    });
    
    // 监听 DOM 变化，如果视频被动态添加，重新修复
    var observer = new MutationObserver(function(mutations) {
        var shouldFix = false;
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (node.tagName === 'VIDEO' || node.querySelector('video'))) {
                    shouldFix = true;
                }
            });
        });
        if (shouldFix) {
            fixVideos();
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
})();
